export default [
  { id: 'spanish', label: 'Español' },
  { id: 'mapuzungun', label: 'Lengua originaria mapuzugun' },
  { id: 'aymara', label: 'Lengua originaria aymara' },
  { id: 'quechua', label: 'Lengua originaria Quechua' },
  { id: 'rapanui', label: 'Lengua originaria rapa nui' },
  { id: 'kawesqa', label: 'Lengua originaria kawésqa' },
  { id: 'yagan', label: 'Lengua originaria yagán' },
  { id: 'english', label: 'Inglés' },
  { id: 'french', label: 'Francés' },
  { id: 'german', label: 'Alemán' },
  { id: 'chinese', label: 'Chino' },
  { id: 'other', label: 'Otro' }
];
